<template>
  <div class="home-page">
    <!-- Header -->
    <TheHeader />

    <!-- Main Content -->
    <main>
      <!-- Hero Section -->
      <HeroSection />

      <!-- Services Section -->
      <ServicesSection />

      <!-- Values Section -->
      <ValuesSection />

      <!-- Contact Section -->
      <ContactSection />

      <!-- Instagram Section -->
      <InstagramSection />
    </main>

    <!-- Footer -->
    <TheFooter />
  </div>
</template>

<script setup lang="ts">
import TheHeader from '@/components/layout/TheHeader.vue';
import TheFooter from '@/components/layout/TheFooter.vue';
import HeroSection from '@/components/home/HeroSection.vue';
import ServicesSection from '@/components/home/ServicesSection.vue';
import ValuesSection from '@/components/home/ValuesSection.vue';
import ContactSection from '@/components/home/ContactSection.vue';
import InstagramSection from '@/components/home/InstagramSection.vue';
</script>

<style scoped>
.home-page {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

main {
  flex: 1;
}
</style>
